import { render, staticRenderFns } from "./template003.vue?vue&type=template&id=2482d965&scoped=true"
import script from "./template003.vue?vue&type=script&lang=js"
export * from "./template003.vue?vue&type=script&lang=js"
import style0 from "./template003.vue?vue&type=style&index=0&id=2482d965&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482d965",
  null
  
)

export default component.exports